__turbopack_context__.v({
  "avatar": "TestimonialCard-module-scss-module__aq-jGG__avatar",
  "container": "TestimonialCard-module-scss-module__aq-jGG__container",
  "isOddIndex": "TestimonialCard-module-scss-module__aq-jGG__isOddIndex",
  "quote": "TestimonialCard-module-scss-module__aq-jGG__quote",
  "quoteIcon": "TestimonialCard-module-scss-module__aq-jGG__quoteIcon",
  "role": "TestimonialCard-module-scss-module__aq-jGG__role",
});
